const Marionette = require('lib/marionette')
const log = require('log').create('try before buy') // eslint-disable-line
const FeatureTracker = require('./feature_tracker')
const features = require('./features')


/**
 * Handles tracking all pro features for a given user. Orchestrates a list of
 * FeatureTrackers, each corresponding to a specific pro feature defined in
 * the features list.
 */
const TrackProFeatures = Marionette.MnObject.extend({
    tracks: [],

    initialize(options) {
        this.user = options.user

        this.createTracks()

        this.listenTo(this.user, 'change:flags.premium', this.createTracks)
    },

    createTracks() {
        this.destroyTracks()

        features.forEach(options => {
            options.user = this.user
            this.tracks.push(new FeatureTracker(options))
        })
    },

    destroyTracks() {
        this.tracks.forEach(track => track.destroy())
        this.tracks = []
    },

    onBeforeDestroy() {
        this.destroyTracks()
        this.stopListening(this.user)
    },

})

module.exports = TrackProFeatures
